import React, { useRef, useState } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";
import styles from "../ResumePage.module.css";

export const ResumeUploadArea = ({ onFileSelect }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    onFileSelect(e.dataTransfer.files);
  };

  const handleInputChange = (e) => {
    onFileSelect(e.target.files);
    e.target.value = "";
  };

  return (
    <div
      className={`${styles.uploadArea} ${isDragging ? styles.dragging : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current?.click()}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleInputChange}
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        multiple
        className={styles.fileInput}
      />
      <IoCloudUploadOutline className={styles.uploadIcon} />
      <p className={styles.uploadText}>
        Drag & drop or <span>browse</span>
      </p>
      <p className={styles.uploadHint}>PDF, DOC, DOCX (Max 10MB)</p>
    </div>
  );
};